import React, { useState } from 'react';
import { mediaContent, mediacoverage } from '../data/mock';
import { ExternalLink } from 'lucide-react';
import mediaHero from "../assets/images/academicBG.webp";


const platforms = [
  { name: "University Website", url: "https://www.du.ac.in" },
  { name: "Ministry Portal", url: "https://www.education.gov.in" },
  { name: "College Website", url: "https://www.maitreyi.ac.in/" },
  { name: "College Notices", url: "https://www.maitreyi.ac.in/notice/general" },
];

const Media = () => {
  const [filter, setFilter] = useState("all");
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredData =
    filter === "all"
      ? mediaContent
      : mediaContent.filter(item => item.type === filter);

  return (
    <div className="min-h-screen pt-20">

      {/* HERO */}
      <section
        className="py-20 text-center"
        style={{
          backgroundImage: `
            linear-gradient(to bottom, rgba(255,247,230,0.9), rgba(192,119,51,0.9)),
            url('${mediaHero}')
          `,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <h1 className="text-4xl md:text-5xl font-bold font-serif">
          Media & Outreach
        </h1>
        <p className="mt-4 text-lg text-muted-foreground">
          Explore our videos, podcasts, and media presence
        </p>
      </section>

      {/* IMPORTANT DOCUMENTS */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">

          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold font-serif">
              Important Documents
            </h2>
            <p className="text-muted-foreground">
              Access official documents and competition guidelines
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">

            <div className="bg-gray-50 p-6 rounded-xl shadow hover:shadow-lg transition">
              <h3 className="font-bold text-lg mb-2">
                Gyanotsava 2026 – Competition Guidelines
              </h3>

              <p className="text-sm text-muted-foreground mb-4">
                Detailed rules, judging criteria, and participation instructions for all academic competitions.
              </p>

              <a
                href="/assets/Guidelines-for-Gyanotsava.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-primary font-semibold hover:underline"
              >
                View Guidelines <ExternalLink className="w-4 h-4" />
              </a>
            </div>

          </div>

        </div>
      </section>

      {/* MEDIA (VIDEOS + PODCAST) */}
      {/* <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">

          {/* FILTERS *}
          <div className="flex justify-center flex-wrap gap-3 mb-10">
            {["all", "youtube", "podcast", "news", "social"].map((item) => (
              <button
                key={item}
                onClick={() => setFilter(item)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition 
                  ${filter === item
                    ? "bg-primary text-white"
                    : "bg-gray-100 hover:bg-primary hover:text-white"}
                `}
              >
                {item.toUpperCase()}
              </button>
            ))}
          </div>

          {/* GRID *}
          <div className="grid md:grid-cols-2 gap-8">
            {filteredData.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden"
              >

                {/* VIDEO EMBED *}
                {(item.type === "youtube" || item.type === "podcast") && (
                  <div className="aspect-video">
                    <iframe
                      src={item.embedUrl}
                      title={item.title}
                      className="w-full h-full"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                    />
                  </div>
                )}

                {/* IMAGE *}
                {(item.type === "news" || item.type === "social") && (
                  <div
                    onClick={() => setSelectedImage(item.thumbnail)}
                    className="h-48 flex items-center justify-center bg-gray-100 cursor-pointer"
                  >
                    <img
                      src={item.thumbnail}
                      alt={item.title}
                      className="max-h-full max-w-full object-contain hover:scale-105 transition"
                    />
                  </div>
                )}

                {/* CONTENT *}
                <div className="p-5">
                  <p className="text-xs text-primary font-semibold uppercase">
                    {item.type}
                  </p>
                  <h3 className="font-bold text-lg mt-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-muted-foreground mt-1">
                    {item.date}
                  </p>
                </div>

              </div>
            ))}
          </div>

        </div>
      </section> */}

      {/* RECENT MEDIA FEATURES (IMPORTANT ADDITION) */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">

          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold font-serif">
              Recent Media Features
            </h2>
            <p className="text-muted-foreground">
              Coverage highlighting our initiatives and impact
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {mediacoverage.map((item, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition"
              >
                <p className="text-sm text-primary font-semibold mb-1">
                  {item.date}
                </p>

                <h3 className="font-bold text-lg mb-2">
                  {item.title}
                </h3>

                <p className="text-sm text-muted-foreground mb-4">
                  Source: {item.source}
                </p>

                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-primary font-semibold hover:underline"
                >
                  Read Article <ExternalLink className="w-4 h-4" />
                </a>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* FEATURED ON */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">

          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold font-serif">
              Featured On
            </h2>
            <p className="text-muted-foreground">
              Online platforms and portals highlighting our work
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {platforms.map((platform, index) => (
              <a
                key={index}
                href={platform.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-50 p-6 rounded-xl text-center shadow hover:shadow-lg hover:scale-105 transition"
              >
                <ExternalLink className="w-6 h-6 mx-auto text-primary mb-2" />
                <p className="text-sm font-semibold">
                  {platform.name}
                </p>
              </a>
            ))}
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-primary to-orange-600 text-white text-center">
        <h2 className="text-3xl font-bold font-serif">
          Media Inquiries
        </h2>
        <p className="mt-3 text-white/90">
          For collaborations, interviews, or press queries
        </p>

        <a
          href="mailto:iks@maitreyi.du.ac.in"
          className="inline-block mt-6 bg-white text-primary px-6 py-3 rounded-full font-semibold hover:scale-105 transition"
        >
          Contact Media Team
        </a>
      </section>

      {selectedImage && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">

          {/* CLOSE BUTTON */}
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-5 right-5 text-white text-3xl font-bold hover:scale-110 transition"
          >
            ✕
          </button>

          {/* IMAGE */}
          <img
            src={selectedImage}
            alt="preview"
            className="max-w-[90%] max-h-[85%] rounded-xl shadow-2xl"
          />

        </div>
      )}

    </div>
  );
};

export default Media;